(function () {
    'use strict';

    angular
        .module('app.core', [
            'ngAnimate',
            'ngSanitize',
            'ui.router',
            'blocks.exception',
            'blocks.logger',
            'blocks.router',
            'blocks.validation',
            'blocks.formly',
            'blocks.smart',
            'blocks.authentication',
            'app.service',
            'ui.bootstrap',
            'smart-table',
            'formly',
            'formlyBootstrap',
            'permission',
            'permission.ui',
            'ncy-angular-breadcrumb',
            'angular-jwt'
        ]);
})();
